import { FrontendSettings } from "../../models/frontendSettings";

/**
 * Resolves whether the summary page shows product detail. When false (flag on), the summary hides the
 * product list (names/article numbers) AND the surface identifiers image; prices stay (governed by
 * hide_price) and action cards are unaffected.
 *
 * Opt out via URL `?hide_product_info=true` or `frontendSettings.hide_product_info`. Mirrors the
 * hide_price idiom — honours both the JSON boolean and the "true" string, since frontendSettings is
 * served from a deployed frontend_settings.json (e.g. Geberit).
 */
export const resolveShowProductInfo = (searchParams: URLSearchParams, frontendSettings: FrontendSettings): boolean => {
    const hideProductInfo = searchParams.get("hide_product_info");
    if (
        (hideProductInfo && /true/i.test(hideProductInfo)) ||
        frontendSettings.hide_product_info === true ||
        /true/i.test(frontendSettings.hide_product_info)
    ) {
        return false;
    }
    return true;
};
